module.exports = __webpack_public_path__ + "img/009.92f424d6.jpg";